import 'whatwg-fetch'
const env = process.env;

const getControllers = (data) => {
    let filter = {
        "limit": data.limit || 500,
        "where":{
            "facility_id": data.facility_id
        },
        "order" : "name",
        "include": {
            "boardComponents":"boardComponentType"
        }
    }

    return fetch(`${env.VUE_APP_trimaster}/api/v1/controllers?access_token=${data.apitoken}&filter=${ encodeURIComponent(JSON.stringify(filter)) }`, {
        method: 'GET',
        headers: {
            Accept: 'application/json'
        }
    })
}

export default {
    getControllers
}
